import React from 'react';
import { Link } from 'gatsby';
import kebabCase from 'lodash.kebabcase'
import {
    Category,
    CategoryList,
} from './styled';

import {
    Container,
    Heading,
    Center,
} from '../../../pageStyles'

const mainCategories = [
  "Hardware",
  "Firmware",
  "Costruzione",
  "Tutorial per volare",
  "Video & Editing",
]

export const Categories = ({list}) => {

    const filteredList = list.filter(el => mainCategories.includes(el))

    return (
        <Container>
            <Center>
              <Heading>
                Categorie
              </Heading>
            </Center>
            <CategoryList>
              {filteredList.map(category => 
                  <Link to={`/categoria/${kebabCase(category)}`}>
                    <Category>
                        {category}
                    </Category>
                  </Link>
                )}
            </CategoryList>
          </Container>
    );
}

